<template>
  <div
    v-loading.fullscreen.lock="fullScreenLoading"
    element-loading-text="loading..."
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.8)"
  >
    <vxe-grid
      ref="table"
      size="small"
      auto-resize
      round
      highlight-hover-row
      :height="tableHeight"
      :toolbar-config="tableToolbar"
      :data="tableData"
      :columns="tableColumn"
      :loading="loading"
      :seq-config="{
        startIndex: (tablePage.curPage - 1) * tablePage.pageSize,
      }"
      row-id="fabricStockInCode"
    >
      <template v-slot:toolbar_form>
        <slot name="header"></slot>
      </template>
      <template v-slot:pager>
        <slot name="pager"></slot>
      </template>
      <template v-slot:defaultImgUrl="{ row }">
        <el-image
          :src="
            row.imageCode
              ? $osscdn(row.imageCode)
              : '/image/static/img/nopic.jpg'
          "
          style="width:100px; height:66px"
        >
          <div slot="error" class="image-slot">
            <img
              src="/image/static/img/nopic.jpg"
              style="width: 100px; height: 66px"
            />
          </div>
        </el-image>
      </template>
      <template v-slot:status="{ row }">
        <el-tag
          size="mini"
          :type="row.fabricStockInStatus === 'Y' ? 'success' : 'danger'"
        >
          {{ row.fabricStockInStatusName }}
        </el-tag>
      </template>
      <template v-slot:widAndWeight="{ row }">
        <span>{{ row.wid }} {{ row.widUnit }}</span>
        <br />
        <span>{{ row.fabricWeight }} {{ row.fabricWeightUnit }}</span>
      </template>
      <template v-slot:priceInfo="{ row }">
        <span>{{ row.unitPrice }} 元/ {{ row.fabricUnit }}</span>
      </template>
      <template v-slot:createInfo="{ row }">
        <span>{{ row.createByName }}</span>
        <br />
        <span>{{ row.createDate }}</span>
      </template>
      <template v-slot:modifyInfo="{ row }">
        <span>{{ row.modifyByName }}</span>
        <br />
        <span>{{ row.modifyDate }}</span>
      </template>
      <template v-slot:opt="{ row }">
        <div>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_tips_view') || '查看'"
            placement="top"
          >
            <i
              class="el-icon-view tool-btn"
              @click="formLoad('detail', row.fabricStockInCode)"
            ></i>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_tips_edit') || '编辑'"
            placement="top"
          >
            <i
              class="el-icon-edit tool-btn"
              @click="formLoad('edit', row.fabricStockInCode)"
              v-show="row.fabricStockInStatus === 'N'"
              v-if="allow('M')"
            ></i>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_tips_del') || '删除'"
            placement="top"
          >
            <i
              class="el-icon-delete tool-btn"
              @click="update(row.fabricStockInCode)"
              v-show="row.fabricStockInStatus === 'N'"
              v-if="allow('D')"
            ></i>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_tips_audit') || '审核'"
            placement="top"
            v-show="row.fabricStockInStatus === 'N'"
            v-if="allow('C')"
          >
            <i
              class="el-icon-check tool-btn"
              @click="audit(row.fabricStockInCode)"
              v-show="row.fabricStockInStatus === 'N'"
              v-if="allow('C')"
            ></i>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_tips_storage') || '入库单打印'"
            placement="top"
            v-show="row.fabricStockInStatus === 'Y'"
            v-if="allow('P')"
          >
            <i
              class="el-icon-printer tool-btn"
              @click="print(row.fabricStockInCode)"
              v-show="row.fabricStockInStatus === 'Y'"
              v-if="allow('P')"
            ></i>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_tips_confirm_receipt') || '确认入库'"
            placement="top"
            v-show="row.fabricFlag === 'Y'"
            v-if="allow('C2')"
          >
            <i
              class="el-icon-folder-checked tool-btn"
              @click="confirmReceipt(row.fabricRequestCode)"
              v-show="row.fabricFlag === 'Y'"
              v-if="allow('C2')"
            ></i>
          </el-tooltip>
        </div>
      </template>
      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data">暂无数据！</p>
        </div>
      </template>
    </vxe-grid>
    <!--选择开发申请单-->
    <el-dialog
      ref="chooseFabricRequest"
      :title="$l('tips_please_select_application_form') || '选择申请单'"
      :visible.sync="fabricRequestVisible"
      :show-close="true"
      :close-on-click-modal="false"
      width="1000px"
      top="10vh"
    >
      <fabric-request
        ref="fabricRequestRef"
        @submitSuccess="fabricRequestSuccess"
      />
    </el-dialog>
  </div>
</template>
<script>
import TableAutoHeight from '@/mixins/table-auto-height'
import FabricRequest from '../choose-fabric-request'
export default {
  mixins: [TableAutoHeight],
  components: {
    FabricRequest,
  },
  props: {
    tableData: {
      default: () => [],
    },
    tablePage: {
      default: null,
      type: Object,
    },
    loading: {
      default: false,
    },
  },
  data() {
    let number = /^[0-9]+$/
    let checkInStockQuantity = (rule, value, callback) => {
      if (value) {
        if (!number.test(value)) {
          callback(new Error(this.$l('tips_eapi') || '入库数量应是正整数'))
        }
        callback()
      } else {
        callback(
          new Error(this.$l('form_label_pfitasq') || '请填写实际入库数量')
        )
      }
      callback()
    }
    return {
      fullScreenLoading: false,
      fabricRequestVisible: false,
      auditDialogVisible: false,
      disabled: false,
      auditData: {
        inStockQuantity: '', // 入库数量
        fabricStockInCode: '', // 主键
        fabricStockInType: '', // 入库单类型
        isDialogInput: 'N', //是否弹框输入
      },
      rules: {
        inStockQuantity: [
          {
            required: true,
            validator: checkInStockQuantity,
            trigger: 'blur',
          },
        ],
      },
      tableToolbar: {
        slots: {
          buttons: 'toolbar_form',
        },
        refresh: {
          query: this.reload,
        },
        zoom: true,
      },
      tableColumn: [
        {
          field: 'col-opt',
          title: this.$l('INDEX.table_label_operation') || '操作',
          align: 'center',
          width: 200,
          fixed: 'right',
          slots: {
            default: 'opt',
          },
        },
        // { width: 50, fixed: 'left', type: this.single ? 'radio' : 'checkbox' },
        {
          field: 'seq',
          width: 60,
          align: 'center',
          type: 'seq',
        },
        {
          field: 'fabricStockInNo',
          width: 150,
          title: this.$l('table_head_fsin') || '面料入库单号',
        },
        {
          field: 'fabricStockInStatus',
          width: 80,
          title: this.$l('table_head_status') || '状态',
          align: 'center',
          slots: { default: 'status' },
        },
        {
          field: 'fabricAgentName',
          width: 120,
          title: this.$l('form_label_bill_name') || '业务员',
        },
        {
          field: 'fabricNo',
          minWidth: 180,
          title: this.$l('form_label_fabric_number') || '面料编号',
        },
        {
          field: 'fabricName',
          minWidth: 250,
          title: this.$l('table_label_fabric_name') || '面料名称',
        },
        {
          field: 'widAndWeight',
          minWidth: 130,
          title: this.$l('form_label_wid_and_weight') || '门幅克重',
          slots: { default: 'widAndWeight' },
        },
        {
          field: 'priceInfo',
          minWidth: 150,
          title: this.$l('form_label_unitPrice') || '单价',
          slots: { default: 'priceInfo' },
        },
        {
          field: 'fabricContent',
          minWidth: 300,
          title: this.$l('table_label_fabric_composition') || '面料成分',
        },
        {
          field: 'scmName',
          minWidth: 250,
          title: this.$l('form_label_supplier') || '供应商',
        },
        {
          field: 'factoryNumber',
          minWidth: 180,
          title: this.$l('form_label_factory_fabric_number') || '工厂面料编号',
        },
        {
          field: 'createInfo',
          width: 170,
          title: 'Create',
          slots: { default: 'createInfo' },
        },
        {
          field: 'modifyInfo',
          width: 170,
          title: 'Modify',
          slots: { default: 'modifyInfo' },
        },
      ],
    }
  },
  methods: {
    reload() {
      this.$emit('submit')
    },
    // 加载表单
    formLoad(ref, val = '') {
      let params = {
        pageType: ref,
        fabricStockInCode: val,
      }
      this.$router.push({
        name: 'master-fabricStockInDetail',
        params: params,
      })
    },
    //打印功能
    print(code) {
      this.$api.printPDF('/digitalCenter/fabricStockIn/print', {
        fabricStockInCode: code,
      })
    },
    // 选择申请单
    chooseFabricRequest() {
      setTimeout(() => {
        this.$refs.fabricRequestRef.reload()
      }, 0)
      this.fabricRequestVisible = true
    },
    // 选择申请单保存成功
    fabricRequestSuccess(fabricStockInCode) {
      this.fabricRequestVisible = false
      this.formLoad('edit', fabricStockInCode)
    },
    update(code) {
      let msg = this.$l('INDEX.tips_question_delete') || '是否删除?'
      this.$confirm(msg, this.$l('INDEX.tips_question_title') || '提示', {
        confirmButtonText: this.$l('INDEX.tips_confirm') || '确定',
        cancelButtonText: this.$l('INDEX.tips_cancel') || '取消',
        type: 'warning',
      }).then(() => {
        this.$api
          .fabricStockInDelApi({
            fabricStockInCode: code,
          })
          .then(() => {
            this.$message.success(
              this.$l('INDEX.tips_delete_ok') || '删除成功!'
            )
            this.$emit('submit')
          })
      })
    },
    audit(fabricStockInCode) {
      let msg = this.$l('INDEX.tips_question_audit') || '是否审核?'
      this.$confirm(msg, this.$l('INDEX.tips_question_title') || '提示', {
        confirmButtonText: this.$l('INDEX.btn_tips_audit') || '确定',
        cancelButtonText: this.$l('INDEX.tips_cancel') || '取消',
        type: 'warning',
      }).then(() => {
        this.fullScreenLoading = true
        this.$api
          .fabricStockInAuditApi({ fabricStockInCode: fabricStockInCode })
          .then(() => {
            this.fullScreenLoading = false
            this.$message.success(this.$l('tips_audit_success') || '审核成功!')
            this.$emit('submit')
          })
          .catch(() => {
            this.fullScreenLoading = false
          })
      })
    },
    //更改申请单的入库状态为已入库
    confirmReceipt(code) {
      let msg =
        this.$l('INDEX.tips_question_confirmReceipt') ||
        '是否更改申请单的入库状态为已入库?'
      this.$confirm(msg, this.$l('INDEX.tips_question_title') || '提示', {
        confirmButtonText: this.$l('INDEX.tips_confirm') || '确定',
        cancelButtonText: this.$l('INDEX.tips_cancel') || '取消',
        type: 'warning',
      }).then(() => {
        this.fullScreenLoading = true
        this.$api
          .fabricStockInChangeRequestStatusApi({ fabricRequestCode: code })
          .then(() => {
            this.fullScreenLoading = false
            this.$message.success(
              this.$l('INDEX.tips_operate_ok') || '操作成功!!'
            )
            this.$emit('submit')
          })
          .catch(() => {
            this.fullScreenLoading = false
          })
      })
    },

    // //需要弹框
    // sendAudit() {
    //   this.$refs.auditData.validate((valid) => {
    //     if (valid) {
    //       this.$api
    //         .fabricStockInAuditApi(this.auditData)
    //         .then(() => {
    //           this.$message.success(
    //             this.$l('tips_audit_success') || '审核成功!'
    //           )
    //           this.auditDialogVisible = false
    //           this.$emit('submit')
    //         })
    //         .catch(() => {
    //           this.auditDialogVisible = false
    //         })
    //     } else {
    //       return false
    //     }
    //   })
    // },
    // closeAudit() {
    //   this.auditDialogVisible = false
    // },
  },
}
</script>
